'use strict';

import angular from 'angular';
import { marked } from 'marked';

marked.use({ breaks: true, gfm: true });

export default angular.module('observatoireApp')
  .controller('ForumController', ['$scope', '$sce', 'Auth', 'ForumService',
    function($scope, $sce, Auth, ForumService) {

      // ── Utilisateur ───────────────────────────────────────────────────────
      $scope.utilisateur = null;
      $scope.utilisateurConnecte = false;

      Auth.identity().then(function(user) {
        if (user) { $scope.utilisateur = user; $scope.utilisateurConnecte = true; }
      }).catch(angular.noop);

      // ── Données ───────────────────────────────────────────────────────────
      $scope.posts = [];
      $scope.postsAffiches = [];
      $scope.postOuvert = null;
      $scope.loading = true;
      $scope.loadingPost = false;
      $scope.erreur = null;
      $scope.filtre = { q: '' };
      $scope.tri = 'recent';

      $scope.categories = ['Tous', 'Finance', 'Budget', 'Pétrole', 'Mines', 'Textes officiels', 'Général'];
      $scope.categorieActive = 'Tous';

      $scope.nouveauPost = { titre: '', contenu: '', categorie: 'Général' };
      $scope.afficherFormPost = false;
      $scope.envoiPost = false;

      $scope.nouvelleReponse = { contenu: '' };
      $scope.envoiReponse = false;

      // ── Charger posts ─────────────────────────────────────────────────────
      function chargerPosts() {
        $scope.loading = true;
        var cat = $scope.categorieActive === 'Tous' ? null : $scope.categorieActive;
        ForumService.getPosts(cat)
          .then(function(data) { $scope.posts = data; $scope.loading = false; })
          .catch(function() { $scope.erreur = 'Impossible de charger les discussions.'; $scope.loading = false; });
      }
      chargerPosts();

      // ── Filtrage + tri ────────────────────────────────────────────────
      function updateListe() {
        var liste = $scope.posts || [];
        var q = ($scope.filtre.q || '').toLowerCase().trim();

        if (q) {
          liste = liste.filter(function(p) {
            return (p.titre || '').toLowerCase().indexOf(q) !== -1 ||
                   (p.contenu || '').toLowerCase().indexOf(q) !== -1;
          });
        }
        if ($scope.tri === 'unanswered') {
          liste = liste.filter(function(p) { return !p.replyCount; });
        }

        var sorted = liste.slice();
        if ($scope.tri === 'votes') {
          sorted.sort(function(a, b) { return (b.voteCount || 0) - (a.voteCount || 0); });
        } else {
          sorted.sort(function(a, b) {
            var da = a.createdAt ? new Date(a.createdAt).getTime() : 0;
            var db = b.createdAt ? new Date(b.createdAt).getTime() : 0;
            return db - da;
          });
        }
        $scope.postsAffiches = sorted;
      }

      $scope.$watch('filtre.q', updateListe);
      $scope.$watch('tri', updateListe);
      $scope.$watchCollection('posts', updateListe);

      $scope.changerTri = function(t) { $scope.tri = t; };

      // ── Catégorie ─────────────────────────────────────────────────────────
      $scope.changerCategorie = function(cat) {
        $scope.categorieActive = cat;
        $scope.postOuvert = null;
        $scope.filtre.q = '';
        chargerPosts();
      };

      // ── Ouvrir post ───────────────────────────────────────────────────────
      $scope.ouvrirPost = function(post) {
        $scope.loadingPost = true;
        $scope.postOuvert = null;
        $scope.nouvelleReponse = { contenu: '' };
        ForumService.getPost(post.id)
          .then(function(data) { $scope.postOuvert = data; $scope.loadingPost = false; })
          .catch(function() { $scope.loadingPost = false; });
      };

      $scope.fermerPost = function() { $scope.postOuvert = null; $scope.nouvelleReponse = { contenu: '' }; };

      // ── Créer post ────────────────────────────────────────────────────────
      $scope.toggleFormPost = function() {
        $scope.afficherFormPost = !$scope.afficherFormPost;
        if (!$scope.afficherFormPost) $scope.nouveauPost = { titre: '', contenu: '', categorie: 'Général' };
      };

      $scope.soumettrPost = function() {
        if (!$scope.utilisateurConnecte || !$scope.nouveauPost.titre.trim() || !$scope.nouveauPost.contenu) return;
        $scope.envoiPost = true;
        ForumService.createPost({
          titre: $scope.nouveauPost.titre,
          contenu: $scope.nouveauPost.contenu,
          categorie: $scope.nouveauPost.categorie,
          auteur: $scope.utilisateur.username || $scope.utilisateur.firstName
        }).then(function(post) {
          $scope.posts.unshift(post);
          $scope.nouveauPost = { titre: '', contenu: '', categorie: 'Général' };
          $scope.afficherFormPost = false;
          $scope.envoiPost = false;
        }).catch(function() { $scope.envoiPost = false; });
      };

      // ── Répondre ──────────────────────────────────────────────────────────
      $scope.soumettreReponse = function() {
        if (!$scope.utilisateurConnecte || !$scope.postOuvert || !$scope.nouvelleReponse.contenu) return;
        $scope.envoiReponse = true;
        ForumService.addReply($scope.postOuvert.id, {
          contenu: $scope.nouvelleReponse.contenu,
          auteur: $scope.utilisateur.username || $scope.utilisateur.firstName
        }).then(function(reply) {
          $scope.postOuvert.replies = $scope.postOuvert.replies || [];
          $scope.postOuvert.replies.push(reply);
          $scope.postOuvert.replyCount = ($scope.postOuvert.replyCount || 0) + 1;
          var p = $scope.posts.find(function(x) { return x.id === $scope.postOuvert.id; });
          if (p) p.replyCount = $scope.postOuvert.replyCount;
          $scope.nouvelleReponse = { contenu: '' };
          $scope.envoiReponse = false;
        }).catch(function() { $scope.envoiReponse = false; });
      };

      // ── Votes ─────────────────────────────────────────────────────────────
      $scope.voterPost = function(post, type) {
        if (!$scope.utilisateurConnecte) return;
        ForumService.votePost(post.id, $scope.utilisateur.username || $scope.utilisateur.firstName, type)
          .then(function(res) { post.voteCount = res.voteCount; }).catch(angular.noop);
      };

      $scope.voterReponse = function(reply, type) {
        if (!$scope.utilisateurConnecte) return;
        ForumService.voteReply(reply.id, $scope.utilisateur.username || $scope.utilisateur.firstName, type)
          .then(function(res) { reply.voteCount = res.voteCount; }).catch(angular.noop);
      };

      // ── Supprimer ─────────────────────────────────────────────────────────
      $scope.supprimerPost = function(post) {
        if (!$scope.utilisateurConnecte || !confirm('Supprimer cette discussion ?')) return;
        ForumService.deletePost(post.id, $scope.utilisateur.username || $scope.utilisateur.firstName)
          .then(function() {
            $scope.posts = $scope.posts.filter(function(p) { return p.id !== post.id; });
            if ($scope.postOuvert && $scope.postOuvert.id === post.id) $scope.postOuvert = null;
          }).catch(angular.noop);
      };

      $scope.supprimerReponse = function(reply) {
        if (!$scope.utilisateurConnecte || !confirm('Supprimer cette réponse ?')) return;
        ForumService.deleteReply(reply.id, $scope.utilisateur.username || $scope.utilisateur.firstName)
          .then(function() {
            $scope.postOuvert.replies = $scope.postOuvert.replies.filter(function(r) { return r.id !== reply.id; });
            $scope.postOuvert.replyCount = Math.max(0, ($scope.postOuvert.replyCount || 1) - 1);
          }).catch(angular.noop);
      };

      // ── Markdown + helpers ────────────────────────────────────────────────
      $scope.renderMd = function(txt) {
        return $sce.trustAsHtml(marked.parse(txt || ''));
      };

      $scope.stripMd = function(txt) {
        return (txt || '').replace(/[#*_`~>\[\]!]/g, '').replace(/\n/g, ' ');
      };

      $scope.estAuteur = function(auteur) {
        if (!$scope.utilisateur) return false;
        return $scope.utilisateur.username === auteur || $scope.utilisateur.firstName === auteur;
      };

      $scope.initiales = function(nom) {
        if (!nom) return '?';
        return nom.slice(0, 2).toUpperCase();
      };
    }
  ]);
